module.exports = __webpack_public_path__ + "img/视频封面24.d7688c35.png";